
import { useContext } from "react"
import { IoIosArrowForward, IoIosClose } from "react-icons/io"
import { CarritoContext } from "../context/CarritoContext"
import { formatter } from "../resources/funciones"
import { useNavigate } from "react-router-dom"
import {useTranslation} from 'react-i18next'
import {ContadorProducto} from './ContadorProducto'

export const CarritoSidebar = () => {

    const { carrito, cerrarCarrito, eliminarProducto, vaciarCarrito, mostrarCarrito, setMostrarCarrito, disminuirCantidad, aniadirCantidad, totalCarrito } = useContext(CarritoContext)

    const navigate = useNavigate()
    const { t } = useTranslation()

    const irComprar = () => {
        navigate("/carrito")
        setMostrarCarrito(false)
    }

    const agregarPodructos = () => {
        cerrarCarrito()
        navigate('/tienda')
    }

    return (
        <div className={`cart ${mostrarCarrito && "active"}`}>
            <div className="contenedor-cart-title">
                <IoIosArrowForward id="close-cart" onClick={cerrarCarrito} />
                <h2 className="cart-title">
                    {t("tienda_carrito_side_cabecera")}
                </h2>
            </div>
            {carrito?.length > 0 ? (
                <div style={{ paddingRight: '0.4rem' }}>
                    <div className="cart-content">
                        {carrito.length > 0 && carrito.map((c, index) => (
                        <div className={`cart-box ${index === carrito.length - 1 ? 'last' : ''}`} key={c?.ProdCod}>
                            <IoIosClose className="cart-remove" onClick={(e) => eliminarProducto(e, c?.ProdCod)} />
                            {/* <div className="d-flex justify-content-end">
                            </div> */}
                            <div className="">
                                <img src={c?.ProdImg} alt="..." className="cart-img" />
                            </div>
                            <div className="cart-product-title">{c?.ProdNom}</div>
                            <div className="d-flex justify-content-between">                                    
                                <div>
                                    {
                                        (!c?.ProdPrecD) ? (
                                            <span className="cart-price">{formatter.format(c?.ProdPrecN)}</span>
                                        ) : (
                                            <span>
                                                <span className="cart-price-discount">{formatter.format(c?.ProdPrecN)}</span>
                                                <span className="ms-2 cart-price">{formatter.format(c?.ProdPrecD)}</span>
                                            </span>
                                        )
                                    }
                                </div>
                                <ContadorProducto contador={c?.Cantidad} aumentarCallback={() => aniadirCantidad(c?.ProdCod)} disminuirCallback={() => disminuirCantidad(c?.ProdCod)}/>                                
                            </div>
                        </div>
                        ))}
                    </div>
                    <hr />
                    <div style={{height:"196px"}}>
                        <div className="total">
                            <div className="total-title">{t("tienda_carrito_side_total")}</div>
                            <div className="total-price">{totalCarrito()}</div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center mt-3">
                            <button type="button" className="btn btn-sm btn-primario-analogo me-2" onClick={vaciarCarrito}>{t("tienda_carrito_side_btn_vaciar")}</button>
                            <button type="button" className="btn btn-sm btn-primario" onClick={irComprar}>{t("tienda_carrito_side_btn_comprar")}</button>
                        </div>

                    </div>
                </div>
            ) : (                
                <div className="d-flex justify-content-center mt-5">
                    <div className="link-deco ">
                        <span className="text-terciario" onClick={agregarPodructos}>{t("tienda_carrito_side_btn_añadir")}</span>
                    </div>
                </div>
            )}
        </div>
    )
}
